import {whitelabelling as Whitelabelling} from 'whitelabelling';

export function userInputCareerGoalsLocations() {
    return {
        restrict: 'E',
        scope: {
            data: '=',
            displayType: '@?',
        },
        templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/directives/userInputs/userInputCareerGoalsLocations.html',
        controller: [
            '$scope', 'RegistrationService', function($scope, RegistrationService) {
                $scope.showAddLocation = false;
                $scope.whitelabelling = Whitelabelling;
                $scope.MAX_TO_ADD = 10;

                $scope.locationsSelector = {
                    value: null,
                };

                $scope.removeLocation = function(l) {
                    $scope.data.remove(l);
                };

                $scope.locationsTipResource = function() {
                    return RegistrationService.getTopLocations($scope.categories);
                };

                $scope.goToNextStep = function() {
                    $scope.$emit('goToNextStep');
                };

                $scope.$on('showErrors', function() {
                    $scope.noInputs = true;
                });

                // because we can add multiple concentrations, we have the intermediate value to store the
                // currently selecting one
                $scope.$watch('locationsSelector.value', function(newVal) {
                    if (newVal && newVal.placeid) {
                        $scope.noInputs = false;
                        $scope.data.add(newVal);
                        $scope.locationsSelector.value = '';
                        $scope.showAddLocation = $scope.data.length < $scope.MAX_TO_ADD;
                    }
                });
            },
        ],
    };
}

